import React from "react"
// nodejs library that concatenates classes
import classNames from "classnames"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons

// React icons
import { FaTwitter, FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa"

// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Button from "components/CustomButtons/Button.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardFooter from "components/Card/CardFooter.jsx"

import teamStyle from "assets/jss/material-kit-react/views/landingPageSections/teamStyle.jsx"

import Manu from "assets/img/faces/manuPic.jpg"
import Alex from "assets/img/faces/alexPic.jpg"
import Patrick from "assets/img/faces/patrickPic.png"

class TeamSection extends React.Component {
  render() {
    const { classes } = this.props
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    )
    return (
      <div className={classes.section}>
        <h2 className={classes.title}>Our Team</h2>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <Card plain>
                <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                  <img src={Alex} alt="..." className={imageClasses} />
                </GridItem>
                <h4 className={classes.cardTitle}>
                  Alex Franch Tapia
                  <br />
                  <small className={classes.smallTitle}>CEO & Co-Founder</small>
                </h4>
                <CardBody>
                  <p className={classes.description}>
                    Computer Science with Management Graduate at King's College
                    London, Network Security Teaching Assistant at King's College.
                    Love Cryptography and playing Padel.
                  </p>
                  <p>
                    <b>+44 (0) 7761 62 50 53</b>
                  </p>
                  <p>
                    <b>alex@privasee.co.uk</b>
                  </p>
                </CardBody>
                <CardFooter className={classes.justifyCenter}>
                  <Button
                    justIcon
                    color="transparent"
                    className={classes.margin5}
                    href="https://twitter.com/a_lextweets"
                    target="_blank"
                  >
                    <FaTwitter />
                  </Button>
                  <Button
                    justIcon
                    color="transparent"
                    className={classes.margin5}
                    href="https://www.linkedin.com/in/alexfranchtapia/"
                    target="_blank"
                  >
                    <FaLinkedin />
                  </Button>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <Card plain>
                <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                  <img src={Manu} alt="..." className={imageClasses} />
                </GridItem>
                <h4 className={classes.cardTitle}>
                  Manuel Martinez Chamorro
                  <br />
                  <small className={classes.smallTitle}>CTO & Co-Founder</small>
                </h4>
                <CardBody>
                  <p className={classes.description}>
                    Computer Science with Management graduate at King's College London,
                    ex-Deloitte Technology Consultant Intern, ex-president of the
                    King’s College Entrepreneurs Society. Star Wars nerd. Favourite book: 1984.
                  </p>
                  <p>
                    <b>+44 (0) 7476 39 13 13</b>
                  </p>
                  <p>
                    <b>manuel@privasee.co.uk</b>
                  </p>
                </CardBody>
                <CardFooter className={classes.justifyCenter}>
                  <Button
                    justIcon
                    color="transparent"
                    className={classes.margin5}
                    href="https://twitter.com/manuel_mch"
                    target="_blank"
                  >
                    <FaTwitter />
                  </Button>
                  <Button
                    justIcon
                    color="transparent"
                    className={classes.margin5}
                    href="https://www.linkedin.com/in/manuel-martinez-chamorro/"
                    target="_blank"
                  >
                    <FaLinkedin />
                  </Button>
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    )
  }
}

export default withStyles(teamStyle)(TeamSection)
